@let item = proposal();
<article class="proposal" [attr.data-status]="item.status" data-testid="dictionary-proposal-card">
  <header class="proposal__header">
    <div class="proposal__heading">
      <h4 class="proposal__account">{{ item.standardAccountLabel ?? 'Conta padrão' }}</h4>
      @if (item.currentEntry?.path; as path) {
        <span class="proposal__path" data-testid="dictionary-proposal-path">{{ path }}</span>
      }
      <div class="proposal__tags">
        <span class="tag tag--statement">{{ statementLabel() }}</span>
        <span class="tag" [attr.data-kind]="item.kind" data-testid="dictionary-proposal-kind">
          {{ kindLabel() }}
        </span>
        @if (!isPending()) {
          <span class="tag tag--status" [attr.data-status]="item.status">{{ statusLabel() }}</span>
        }
        @if (item.occurrences > 1) {
          <span class="tag tag--count" title="Vezes em que o revisor propôs a mesma mudança">
            Proposta {{ item.occurrences }} vezes
          </span>
        }
      </div>
    </div>
    @if (item.lastSeenAt || item.createdAt) {
      <span class="proposal__when">
        {{ item.occurrences > 1 ? 'Última vez em' : 'Em' }}
        {{ item.lastSeenAt ?? item.createdAt | vaultDateTime }}
      </span>
    }
  </header>

  @if (item.entryHasHouseDecisions && isPending()) {
    <p class="proposal__warning" role="note">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>
        Este verbete tem decisão da casa registrada. Confira se a proposta não contradiz a decisão
        antes de aplicar.
      </span>
    </p>
  }

  <div class="proposal__body">
    <section class="proposal__side proposal__side--new" aria-label="O que o revisor propõe">
      <span class="proposal__label">
        {{ isDefinition() ? 'Definição proposta' : 'Texto novo' }}
      </span>
      <p class="proposal__new-text" data-testid="dictionary-proposal-text">
        <i class="pi pi-plus" aria-hidden="true"></i>
        <span>{{ newText() }}</span>
      </p>

      @if (item.rationale) {
        <span class="proposal__label">Por que o revisor propôs</span>
        <p class="proposal__text">{{ item.rationale }}</p>
      }

      @if (item.clientAccountLabel || item.companyName) {
        <dl class="proposal__origin">
          @if (item.clientAccountLabel) {
            <div>
              <dt>Linha que motivou</dt>
              <dd>{{ item.clientAccountLabel }}</dd>
            </div>
          }
          @if (item.companyName) {
            <div>
              <dt>Empresa</dt>
              <dd>{{ item.companyName }}</dd>
            </div>
          }
        </dl>
      }
      @if (canOpenDocument()) {
        <button
          type="button"
          class="proposal__link"
          data-testid="dictionary-proposal-open-document"
          (click)="openDocument()">
          <i class="pi pi-external-link" aria-hidden="true"></i>
          Abrir o documento que motivou
        </button>
      }
    </section>

    <section class="proposal__side proposal__side--current" aria-label="Verbete atual">
      <span class="proposal__label">{{ sectionLabel() }}</span>
      @if (isDefinition()) {
        @if (currentDefinition(); as definition) {
          <p class="proposal__old-text">{{ definition }}</p>
        } @else {
          <p class="proposal__muted">O verbete ainda não tem definição.</p>
        }
        <p class="proposal__diff-new">{{ newText() }}</p>
      } @else {
        <ul class="proposal__list">
          @if (hiddenItemCount() > 0) {
            <li class="proposal__muted">
              e mais {{ hiddenItemCount() }} {{ hiddenItemCount() === 1 ? 'item' : 'itens' }}
              antes
            </li>
          }
          @for (current of shownItems(); track $index) {
            <li>{{ current }}</li>
          }
          <li class="proposal__diff-new">{{ newText() }}</li>
        </ul>
      }
      @if (!item.currentEntry) {
        <p class="proposal__muted">
          O verbete atual não veio com a proposta; ele aparece na aba Verbetes.
        </p>
      }
    </section>
  </div>

  @if (isPending()) {
    @if (canManage()) {
      <footer class="proposal__actions">
        <app-button
          [label]="'Recusar'"
          [theme]="'white'"
          [type]="'button'"
          [disabled]="locked()"
          data-testid="dictionary-proposal-reject"
          (sendButtonClick)="rejectRequested.emit(item)" />
        <app-button
          [label]="'Editar e aplicar'"
          [theme]="'white'"
          [type]="'button'"
          [disabled]="locked()"
          data-testid="dictionary-proposal-edit-apply"
          (sendButtonClick)="editApplyRequested.emit(item)" />
        <app-button
          [label]="'Aplicar'"
          [theme]="'default'"
          [type]="'button'"
          [disabled]="locked()"
          [isLoading]="busy()"
          [loadingText]="'Aplicando...'"
          data-testid="dictionary-proposal-apply"
          (sendButtonClick)="applyRequested.emit(item)" />
      </footer>
    }
  } @else {
    <p class="proposal__decided" data-testid="dictionary-proposal-decision">
      {{ statusLabel() }}{{ item.autoApplied ? ' sozinha' : '' }}
      @if (item.appliedVersionNumber) {
        na versão {{ item.appliedVersionNumber }}
      }
      @if (item.decidedByName && !item.autoApplied) {
        por {{ item.decidedByName }}
      }
      @if (item.decidedAt) {
        em {{ item.decidedAt | vaultDateTime }}
      }
      @if (item.reviewedAt) {
        · {{ item.status === 'Reverted' ? 'desfeita' : 'mantida' }}
        @if (item.reviewedByName) {
          por {{ item.reviewedByName }}
        }
        em {{ item.reviewedAt | vaultDateTime }}
      }
      @if (item.decisionNote) {
        : "{{ item.decisionNote }}"
      }
    </p>
  }
</article>
